import { TimelineSummary } from '../models/timeline-summary.model';
import { TimelineKind } from '../models/enums/timeline-kind.enum';

export const CatchUpLabel = 'Catch-up';

// [#1314] The seller and the admin see an engagement's catch-ups as "Catch-up 1", "Catch-up 2", ... in the order
// they were started; a retired one keeps its number, which is why the ordinal is counted over every catch-up
// master the engagement ever had, not only the active ones.
export const catchUpOrdinalOf = (
    timelineId: number,
    summaries: TimelineSummary[]
): number | undefined => {
    const catchUpIds = summaries
        .filter((summary) => summary.kind === TimelineKind.CATCH_UP_MASTER)
        .map((summary) => summary.timelineId)
        .sort((first, second) => first - second);
    const index = catchUpIds.indexOf(timelineId);
    return index < 0 ? undefined : index + 1;
};

export const formatCatchUpName = (ordinal: number | undefined): string =>
    ordinal === undefined ? CatchUpLabel : `${CatchUpLabel} ${ordinal}`;

export const catchUpRiddenBy = (
    buyerId: number,
    summaries: TimelineSummary[]
): TimelineSummary | undefined => {
    const ownTimeline = summaries.find(
        (summary) => summary.kind === TimelineKind.BUYER && summary.buyerId === buyerId
    );
    return summaries.find(
        (summary) =>
            summary.kind === TimelineKind.CATCH_UP_MASTER &&
            summary.timelineId === ownTimeline?.masterTimelineId
    );
};

export const ridersOf = (catchUpTimelineId: number, summaries: TimelineSummary[]): number[] =>
    summaries
        .filter(
            (summary) =>
                summary.kind === TimelineKind.BUYER &&
                summary.masterTimelineId === catchUpTimelineId &&
                summary.buyerId !== undefined
        )
        .map((summary) => summary.buyerId);
